export class SearchPaging {
  currentPage?: number;
  pageSize?: number = 10;
  fetchAllRecord?: boolean;
}
